<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>运营中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a>工作日志</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section>
      <section class="searchBox">
        <div></div>
        <span>
          <label>日期：</label>
          <a-range-picker
            v-model="date"
            :placeholder="['开始时间', '结束时间']"
            @change="onChangeDate"
          />
        </span>
        <span>
          <label>姓名：</label>
          <div>
            <a-input placeholder="请输入姓名" v-model="nameSearch" />
          </div>
        </span>
        <span class="searchStyle">
          <a-button style="margin-right:10px" @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.update_time.substring(0, 10) }}</td>
              <td>{{ item.visit_user_name }}</td>
              <td>{{ item.customer_user_name }}</td>
              <td>
                <span v-for="(element, j) in item.customer_role_info" :key="j">
                  <span v-show="j > 0">|</span>
                  <span>{{ element.role_name }}</span>
                </span>
              </td>
              <td>{{ item.project_name }}</td>
              <td>
                <span v-if="item.visit_type == 1">电话</span>
                <span v-else-if="item.visit_type == 2">面访</span>
                <span v-else>社交APP</span>
              </td>
              <td>
                <p>{{ item.communicate }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: ["日期", "姓名", "岗位", "日志内容"],
      nameSearch: "",
      start_date: "",
      end_date: "",
      date: null
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    onChangeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      //  console.log(this.searchDate);
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      // console.log(this.start_date);
      let url =
        this.httpsBasic.url +
        this.httpsBasic.customer +
        "Customer/queryAllUserCustomerVisit";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.nameSearch,
        token: window.localStorage.getItem("xnwfPcToken"),
        start_date: this.start_date,
        end_date: this.end_date
      };
      if (this.start_date == "" || this.start_date == undefined) {
        delete params.start_date;
      }
      if (this.end_date == "" || this.end_date == undefined) {
        delete params.end_date;
      }
      axios
        .post(url, params)
        .then(res => {
          //   console.log(res);
          if (res.data.code == 200) {
            // this.data = res.data.data.data;
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    onReset() {
      this.date = undefined;
      this.start_date = "";
      this.end_date = "";
      this.nameSearch = "";
      this.page = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchStyle {
    > input {
      margin: 0 20px;
      width: 200px;
    }
  }
  .searchBox {
    justify-content: flex-end;
    > span {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 20px;
      > div {
        display: inline-block;
      }
    }
  }
}
</style>
